import React from "react";
import { useI18n } from "../i18n/LanguageContext";

/**
 * Kleines "KI Generiert"-Etikett für die Ecke von Popup-Fenstern.
 * Erfüllt die Transparenzanforderung gemäß KI-Verordnung (EU) 2024/1689, Art. 50.
 */
export default function AiBadge({ className = "" }) {
  const { t } = useI18n();
  const label = t.ai?.generated || "KI Generiert";

  return (
    <span
      data-testid="ai-generated-badge"
      className={`pointer-events-none select-none text-[9px] font-medium uppercase tracking-wider text-black ${className}`}
    >
      {label}
    </span>
  );
}